import { useSignal } from '@preact/signals'

import {
	ChevronRightIcon,
	DownIcon,
	HorizontalDivider,
	Typography,
	UpIcon,
	ViewMoreButton
} from 'components'

type PlanFeature = {
	feature: string
	community: string | boolean
	startup: string | boolean
}

const features: PlanFeature[] = [
	{
		feature: 'Additional Information',
		community: 'Unlimited',
		startup: 'Unlimited'
	},
	{
		feature: 'Additional Information',
		community: '$0 spend limit\n With policies and controls',
		startup: '$0 spend limit\n With policies and controls'
	},
	{
		feature: 'Additional Information',
		community: '2,000 minutes/month\n Free for public repositories',
		startup: '2,000 minutes/month\n Free for public repositories'
	},
	{
		feature: 'Additional Information',
		community: '500 MB\n Free for public repositories',
		startup: '500 MB\n Free for public repositories'
	},
	{ feature: 'Additional Information', community: true, startup: true },
	{ feature: 'Additional Information', community: true, startup: true },
	{ feature: 'Additional Information', community: 'TBD', startup: 'TBD' }
]

const renderFeatureValue = (value: string | boolean) => {
	if (typeof value === 'boolean') {
		return value ? '✔' : '✖'
	}

	return (
		<Typography
			class='whitespace-pre-wrap'
			color='text-black-200'
			text={value}
			variant='text3'
		/>
	)
}

const ComparisonTable = () => {
	const loadMoreDApss = useSignal(false)

	return (
		<>
			{/* Accordion Content */}
			<div
				class={`overflow-hidden transition-all duration-300 ${
					loadMoreDApss.value
						? 'mb-5 max-h-[1000px] opacity-100'
						: 'max-h-0 opacity-0'
				}`}
			>
				<div class='rounded-md border border-black-800 bg-black-850 p-6'>
					<Typography
						color='text-black-100'
						text='Compare Features'
						variant='h4'
					/>

					{/* Table Container */}
					<div class='mt-6 grid grid-cols-[1fr_2fr] gap-2.5 text-center'>
						{/* Left Side - Expandable Sections */}
						<div class='space-y-6 py-5'>
							<div class='mt-6 h-16' />
							{features.map(({ feature }, index) => (
								// TODO: Remove this once api is ready
								// eslint-disable-next-line react/no-array-index-key
								<div class='flex h-8 items-center' key={index}>
									<ChevronRightIcon className='mr-2' />
									<Typography
										color='text-black-100'
										text={feature}
										variant='text3'
									/>
								</div>
							))}
						</div>

						{/* Right Side - Feature Comparison */}
						<div class='grid grid-cols-2 gap-2.5'>
							{/* Community Plan */}
							<div class='space-y-6 rounded-md border border-black-800 bg-black-850 p-5'>
								<div class='space-y-4'>
									<Typography text='Community' variant='h4' />

									<div class='flex items-center justify-center'>
										<Typography
											color='text-black-100'
											text='$4 USD'
											variant='text1'
											weight='font-normal'
										/>
										<Typography
											class='ml-'
											color='text-black-200'
											text='per user/month'
											variant='text3'
											weight='font-normal'
										/>
									</div>
								</div>

								<HorizontalDivider className='my-4' />

								{features.map(({ community }, index) => (
									// TODO: Remove this once api is ready
									// eslint-disable-next-line react/no-array-index-key
									<div class='flex h-8 items-center justify-center' key={index}>
										{renderFeatureValue(community)}
									</div>
								))}
							</div>

							{/* Startup Plan */}
							<div class='space-y-6 rounded-md border border-black-800 bg-black-850 p-5'>
								<div class='space-y-4'>
									<Typography text='Startup' variant='h4' />

									<div class='flex items-center justify-center'>
										<Typography
											color='text-black-100'
											text='$4 USD'
											variant='text1'
											weight='font-normal'
										/>
										<Typography
											class='ml-'
											color='text-black-200'
											text='per user/month'
											variant='text3'
											weight='font-normal'
										/>
									</div>
								</div>

								<HorizontalDivider className='my-4' />

								{features.map(({ startup }, index) => (
									<div
										class='flex h-8 items-center justify-center'
										// TODO: Remove this once api is ready
										// eslint-disable-next-line react/no-array-index-key
										key={index}
									>
										{renderFeatureValue(startup)}
									</div>
								))}
							</div>
						</div>
					</div>
				</div>
			</div>

			{/* View More Button */}
			<ViewMoreButton
				icon={
					loadMoreDApss.value ? (
						<UpIcon className='h-2.5 w-2.5 text-black-200 group-hover:text-product' />
					) : (
						<DownIcon className='h-2.5 w-2.5 text-black-200 group-hover:text-product' />
					)
				}
				onClick={() => {
					loadMoreDApss.value = !loadMoreDApss.value
				}}
				text={loadMoreDApss.value ? 'Hide Plans Comparison' : 'Compare Plans'}
			/>
		</>
	)
}

export { ComparisonTable }
